import * as React from 'react';
import Modal from 'react-modal';

import DeviceSettingsItemTemplate from './DeviceSettingsItemTemplate';
import { DeviceSettingsDevice } from '../DeviceSettings';
import EnableOrDisableDeviceMutationContainer from 'settings/containers/EnableOrDisableDeviceMutationContainer';
import RemoveDeviceFromUserConfirmDialog from 'settings/components/RemoveDeviceFromUserConfirmDialog';

export type Props = {
  pushDevice: DeviceSettingsDevice;
  isRosteredEnforcement: boolean;
};

type State = {
  confirmRemoveDialogIsOpen: boolean;
};

const mapTypeToOS = {
  apns: 'iOS',
  gcm: 'Android',
};

export default class DeviceSettingsPushItem extends React.Component<Props, State> {
  state = {
    confirmRemoveDialogIsOpen: false,
  };

  showConfirmRemoveDialog = () => {
    this.setState({ confirmRemoveDialogIsOpen: true });
  };

  hideConfirmRemoveDialog = () => {
    this.setState({ confirmRemoveDialogIsOpen: false });
  };

  renderSecondaryText = () => {
    const { pushDevice } = this.props;
    const { model, type, osVersion, appVersion } = pushDevice;
    const appVersionText = appVersion ? `v${appVersion}` : undefined;
    const osVersionText =
      osVersion && (type === 'apns' || type === 'gcm')
        ? `${mapTypeToOS[type]} ${osVersion}`
        : undefined;
    return [appVersionText, model, osVersionText].filter(str => !!str).join(' • ');
  };

  render() {
    const { pushDevice, isRosteredEnforcement } = this.props;
    const { type } = pushDevice;
    const defaultLabel = type === 'apns' || type === 'gcm' ? mapTypeToOS[type] : 'Push device';

    return (
      <React.Fragment>
        <Modal data-test="remove-push-device-modal" isOpen={this.state.confirmRemoveDialogIsOpen}>
          <RemoveDeviceFromUserConfirmDialog
            deviceName={pushDevice.label || 'Your device'}
            deviceId={pushDevice.id}
            onRequestHide={this.hideConfirmRemoveDialog}
          />
        </Modal>
        <EnableOrDisableDeviceMutationContainer>
          {enableOrDisableDevice => (
            <DeviceSettingsItemTemplate
              deviceType={type}
              deviceExists
              deviceIsRostered={pushDevice.rostered && isRosteredEnforcement}
              deviceIsEnabled={pushDevice.enabled}
              deviceCanBeEnabledOrDisabled
              primaryTextLabel={pushDevice.label || defaultLabel}
              secondaryTextLabel={this.renderSecondaryText()}
              onRemoveDevice={this.showConfirmRemoveDialog}
              onEnableOrDisableDevice={() =>
                enableOrDisableDevice({
                  variables: { deviceId: pushDevice.id, enabled: !pushDevice.enabled },
                })
              }
            />
          )}
        </EnableOrDisableDeviceMutationContainer>
      </React.Fragment>
    );
  }
}
